<template>
  <div class="bet_match_wrap">

    <div class="_device summary">
      <h2 class="title">예측배틀</h2>
      <a class="btn_prev_page" href="javascript:history.back();">이전페이지</a>
    </div>

    <div class="bet_match_area">

      <div class="summary">
        <div class="tab">
          <ul>
            <li>
              <router-link
                :to="{ path: path, query : { page:page, type : '', sportsId : '' } }"
                :class="{selected:type === ''}"
                onclick="gaEventer('예측배틀 - 리스트', '게임')">게임 리스트
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ path: path, query : { page:page, type : 'my', status : '' } }"
                :class="{selected:type === 'my'}"
                onclick="gaEventer('예측배틀 - 리스트', '내 게임')">내 게임
              </router-link>
            </li>
          </ul>
        </div>
        <div class="option">
          <ul class="op_game_type">
            <li v-for="(item, key) in statusList" :key="key">
              <router-link
                :class="{selected:gameType === key}"
                :to="{ path: path, query : { page:page, type : type, gameType : key, sportsId : sportsId } }"
                @click.native="gaSender('예측배틀 - 리스트 경기 타입', item)"> {{ item }}
              </router-link>
            </li>
          </ul>
          <ul class="op_event">
            <li v-for="(item, key) in sportsCategory" :key="key" v-if="type===''">
              <router-link
                :class="{selected:sportsId === item.id}"
                :to="{ path: path, query : { page:page, type : type, gameType : gameType, sportsId : item.id } }"
                @click.native="gaSender('예측배틀 - 리스트 종목', item.text)"> {{ item.text }}
              </router-link>
            </li>
            <li v-for="(item, key) in mypageCategory" :key="key" v-if="type==='my'">
              <router-link
                :class="{selected:status === item.id}"
                :to="{ path: path, query : { page:page, type : type, gameType : gameType, status : item.id } }"
                @click.native="gaSender('예측배틀 - 리스트 내 게임 타입', item.text)"> {{ item.text }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="game_list">
        <matchListItem v-for="(item, key) in userMatchList" :item="item" :key="key" :type="loc" />
        <div class="no_history" v-if="userMatchList.length <= 0 && loaded">진행중인 게임이 없습니다.</div>
      </div>

      <div class="btn_area">
        <button class="btn_create" @click="openCreate">게임 만들기</button>
      </div>

    </div>

    <matchCreate v-if="isCreate"/>

    <matchBetSlip v-if="isBetSlip"/>

    <matchDetail v-if="isMatchDetail" :type="loc"/>

    <matchRetry v-if="isMatchRetry"/>

  </div>
</template>

<script>
  import pagenation from '@/components/pagenation'
  import matchListItem from '@/components/match/match-list-item'
  import matchCreate from '@/components/match/match-create'
  import matchBetSlip from '@/components/match/match-bet-slip'
  import matchDetail from '@/components/match/match-detail'
  import matchRetry from '@/components/match/match-retry'

  export default {
    name: "match-wrap",
    components: {
      pagenation,
      matchCreate,
      matchListItem,
      matchBetSlip,
      matchDetail,
      matchRetry
    },
    data() {
      return {
        matchDetail:false,
        loaded: false,
        page: this.$route.query.page ? this.$route.query.page : 1,
        totalEntries: 0,
        totalPage: 1,
        totalCount: 0,
        pageSize: 12,
        status : this.$route.query.status ? parseInt(this.$route.query.status) : '',
        type: this.$route.query.type ? this.$route.query.type : '',
        path: this.$route.path,
        gameType: this.$route.query.gameType ? this.$route.query.gameType : 'all',
        sportsId: this.$route.query.sportsId ? parseInt(this.$route.query.sportsId) : '',
        loc: ''
      }
    },
    created() {
      this.getList();
      this.$eventBus.$on("matchList", this.getList);
    },
    methods: {
      async getList() {
        let res = await this._get("/v1/match/betMatch", this.condition);
        this.$store.dispatch('match/userMatch', res.data.list);
        this.loc = res.data.type
        this.loaded = true
      },
      openCreate() {
        gaEventer('예측배틀 - 리스트', '게임 만들기');
        this.$store.dispatch('match/openCreate');
      },
      gaSender(category, label) {
        gaEventer(category, label)
      }
    },
    computed: {
      condition() {
        return {
          page: this.page,
          type: this.type,
          sportsId: this.sportsId,
          gameType: this.gameType,
          status: this.status,
        }
      },
      userMatchList() {
        return this.$store.getters['match/userMatchList'];
      },
      isCreate() {
        return this.$store.getters['match/isCreate'];
      },
      isBetSlip() {
        return this.$store.getters['match/isBetSlip'];
      },
      isMatchDetail() {
        return this.$store.getters['match/isMatchDetail'];
      },
      isMatchRetry() {
        return this.$store.getters['match/isMatchRetry'];
      },
    },
    watch: {
      '$route'(to) {
        this.status = to.query.status ? parseInt(to.query.status) : '';
        this.page = to.query.page ? parseInt(to.query.page) : 1;
        this.type = to.query.type ? to.query.type : '';
        this.sportsId = to.query.sportsId ? parseInt(to.query.sportsId) : '';
        this.gameType = to.query.gameType ? to.query.gameType : 'all';
        this.getList();
      },
      userMatchList() {
        return this.$store.getters['match/userMatchList'];
      },
      isCreate() {
        return this.$store.getters['match/isCreate'];
      },
      isBetSlip() {
        return this.$store.getters['match/isBetSlip'];
      },
      isMatchDetail() {
        return this.$store.getters['match/isMatchDetail'];
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/match/match-wrap.vue